var config = {

  // production
  server:'//api.cocorobo.cn',
  basename:'/',   
  host:'//cocorobo.cn',
  // reCaptchaSiteKey:'6Le4c4AUAAAAAJVIiYp3e0fO3KqyVo_FWdwBDf9Y'

}

export default config;
